"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _text = require("@mmc/text");
var _reactRedux = require("react-redux");
var _actions = require("../../actions");
var _additionalEquipmentUi = _interopRequireDefault(require("./additional-equipment-ui/additional-equipment-ui"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function AdditionalEquipment(props) {
  var selectedModelCode = props.model,
    market = props.market,
    _props$data = props.data,
    _props$data$equipment = _props$data.equipmentList,
    equipmentList = _props$data$equipment === void 0 ? [] : _props$data$equipment,
    title = _props$data.headingText.title,
    _props$data$carousel = _props$data.carousel,
    carousel = _props$data$carousel === void 0 ? {} : _props$data$carousel,
    disclaimer = _props$data.disclaimer,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? {} : _props$theme,
    addPriceDisclaimer = props.addPriceDisclaimer,
    priceDisclaimerId = props.priceDisclaimerId,
    disclaimerData = props.disclaimerData,
    direction = props.direction,
    dispatch = props.dispatch;
  (0, _react.useEffect)(function () {
    if (!selectedModelCode && equipmentList.length) {
      dispatch((0, _actions.setModel)(equipmentList[0].code));
    }
  }, []);
  var onEquipmentOptionSelected = function onEquipmentOptionSelected(selectedModelCodeFromTrimLine) {
    dispatch((0, _actions.setModel)(selectedModelCodeFromTrimLine));
  };
  return /*#__PURE__*/_react["default"].createElement(_additionalEquipmentUi["default"], {
    selectedModelCode: selectedModelCode,
    equipmentList: equipmentList,
    title: title,
    theme: theme,
    carousel: carousel,
    disclaimerData: disclaimerData,
    addPriceDisclaimer: addPriceDisclaimer,
    priceDisclaimerId: priceDisclaimerId,
    direction: direction,
    onEquipmentOptionSelected: onEquipmentOptionSelected,
    disclaimer: disclaimer,
    market: market
  });
}
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    model: state.model.value,
    transmissionType: state.transmissionType.value,
    theme: props.theme,
    data: props.data
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(AdditionalEquipment);
exports["default"] = _default;